import { render, staticRenderFns } from "./BaseCategorySelectorBox.vue?vue&type=template&id=a9e9fcea&scoped=true&"
import script from "./BaseCategorySelectorBox.vue?vue&type=script&lang=js&"
export * from "./BaseCategorySelectorBox.vue?vue&type=script&lang=js&"
import style0 from "./BaseCategorySelectorBox.vue?vue&type=style&index=0&id=a9e9fcea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9e9fcea",
  null
  
)

export default component.exports